import { render, staticRenderFns } from "./StatusFilters.vue?vue&type=template&id=c382b46c&scoped=true&"
import script from "./StatusFilters.vue?vue&type=script&lang=js&"
export * from "./StatusFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c382b46c",
  null
  
)

export default component.exports